import { Component, Input } from '@angular/core';


export class EventsStatsComponent {
	 public showChart = true;
	 public uiEventsReport = {
		events: [],
		stats: {
			'paste': 0,
			'copy': 0,
			'tab-hidden': 0,
			'tab-displayed': 0,
			'tab-focus-in': 0,
			'tab-focus-out': 0,
			'code-run': 0
		}
	};
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/shared/components/hack-results-viewer/events-stats.component.ts